import React, { useState, useEffect } from "react";
import { Layer, Line, Arrow, Text, Circle, Image } from "react-konva";
//import globalVectorVariable from './globalVectorVariable';

const rulerColor = "black";
const rulerTextFolor = "grey";

const RulerLayer = ({
  gridSize,
  stepSize,
  gridLinesHorizondal,
  gridLinesVertical,
  height,
  width,
  graphXOrigin,
  rulerXPoint,
  rulerYPoint,
  graphYOrigin,
  rulerXLabel,
  rulerYLabel,
  rulerNXLabel,
  rulerNYLabel,
  opacity,
  GridClick
}) => {
  const [xLabel, setXLabel] = useState(undefined);
  const [xNegativeLabel, setNegativeXLabel] = useState(undefined);
  const [yLabel, setYLabel] = useState(undefined);
  const [yNegativeLabel, setNegativeYLabel] = useState(undefined);

  useEffect(() => {
    const xLabelText = rulerXLabel ? rulerXLabel : "";
    const yLabelText = rulerYLabel ? rulerYLabel : "";
    const xNegativeLabelText = rulerNXLabel ? rulerNXLabel : "";
    const yNegativeLabelText = rulerNYLabel ? rulerNYLabel : "";

    const xObject = window.MathJax.tex2svg(xLabelText);
    if (xObject) {
      const s = new XMLSerializer().serializeToString(xObject.children[0]);
      const encodedData = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(s)))}`;
      const current = new window.Image();
      current.src = encodedData;
      current.addEventListener("load", () => {
        setXLabel(current);
      });
    }
    const xNegativeObject = window.MathJax.tex2svg(xNegativeLabelText);
    if (xNegativeObject) {
      const s = new XMLSerializer().serializeToString(xNegativeObject.children[0]);
      const encodedData = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(s)))}`;
      const current = new window.Image();
      current.src = encodedData;
      current.addEventListener("load", () => {
        setNegativeXLabel(current);
      });
    }

    const yObject = window.MathJax.tex2svg(yLabelText);
    if (yObject) {
      const s = new XMLSerializer().serializeToString(yObject.children[0]);
      const encodedData = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(s)))}`;
      const current = new window.Image();
      current.src = encodedData;
      current.addEventListener("load", () => {
        setYLabel(current);
      });
    }
    const yNegativeObject = window.MathJax.tex2svg(yNegativeLabelText);
    if (yNegativeObject) {
      const s = new XMLSerializer().serializeToString(yNegativeObject.children[0]);
      const encodedData = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(s)))}`;
      const current = new window.Image();
      current.src = encodedData;
      current.addEventListener("load", () => {
        setNegativeYLabel(current);
      });
    }

  }, [rulerXLabel, rulerYLabel, rulerNXLabel, rulerNYLabel]);
  //Ruler Marks
  const NumberLines = () => {
    const numberLines = [];
    const verticalXCenter = gridSize.originX + stepSize * 5;
    const intersectionPointY = gridLinesHorizondal.current - 5;
    for (let i = 0; i <= gridLinesHorizondal.current; i = i + 5) {
      numberLines.push(
        <Line
          key={`ruler-line-vertical-${i}`}
          points={[
            verticalXCenter - stepSize / 2,
            gridSize.originY + i * stepSize,
            verticalXCenter + stepSize / 2,
            gridSize.originY + i * stepSize,
          ]}
          stroke={rulerColor}
          strokeWidth={2}
          opacity={opacity}
          //opacity={globalVectorVariable.arrowClicked? 0.2:1}
        />
      );

      if (
        (intersectionPointY - i) % 10 === 0 &&
        intersectionPointY - i !== 0 &&
        i !== 0
      ) {
        numberLines.push(
          <Text
            key={`ruler-text-vertical-${i}`}
            text={intersectionPointY - i}
            fontSize={Math.log(width) * 2.5}
            fill={rulerTextFolor}
            strokeWidth={2}
            x={verticalXCenter - stepSize * 2}
            y={gridSize.originY + (i - 0.5) * stepSize}
            opacity={opacity}
          />
        );
      }
    }
    const verticalYCenter = graphYOrigin.current - stepSize * 5;
    for (let i = 0; i <= gridLinesVertical.current; i = i + 5) {
      numberLines.push(
        <Line
          key={`ruler-line-horizondal-${i}`}
          points={[
            gridSize.originX + i * stepSize,
            verticalYCenter - stepSize / 2,
            gridSize.originX + i * stepSize,
            verticalYCenter + stepSize / 2,
          ]}
          stroke={rulerColor}
          strokeWidth={2}
          opacity={opacity}
          //opacity={globalVectorVariable.arrowClicked? 0.2:1}
        />
      );
      if (
        (i + 5) % 10 === 0 &&
        i - 5 !== 0 &&
        i !== 0 &&
        i !== gridLinesVertical.current
      ) {
        numberLines.push(
          <Text
            key={`ruler-text-horizondal-${i}`}
            text={i - 5}
            fontSize={Math.log(width) * 2.5}
            fill={rulerTextFolor}
            strokeWidth={2}
            fontStyle="italic"
            x={gridSize.originX + (i - 0.5) * stepSize}
            y={verticalYCenter + stepSize}
            opacity={opacity}
          />
        );
      }
    }
    return numberLines;
  };
  
  console.log('RulerLayer', rulerXPoint, rulerYPoint)
  // If the Axes Point is Empty or not defined, Setting the default value 5
  rulerXPoint = (rulerXPoint && rulerXPoint !== '' && rulerXPoint !== null) ? rulerXPoint : 5;
  rulerYPoint = (rulerYPoint && rulerYPoint !== '' && rulerYPoint !== null) ? rulerYPoint : 5;

  return (
    <Layer>
      <Arrow
        points={[
          5,
          gridSize.originY + gridSize.height - stepSize * rulerXPoint,
          width - 5,
          gridSize.originY + gridSize.height - stepSize * rulerXPoint,
        ]}
        fill ={rulerColor}
        stroke={rulerColor}
        pointerWidth={8}
        pointerAtBeginning
        strokeWidth={2.5}
        opacity={opacity}
        //opacity={globalVectorVariable.arrowClicked? 0.2:1}
        onClick={GridClick}
      />
      <Arrow
        points={[
          gridSize.originX + stepSize * rulerYPoint,
          5,
          gridSize.originX + stepSize * rulerYPoint,
          height - 5,
        ]}
        fill ={rulerColor}
        stroke={rulerColor}
        pointerWidth={8}
        pointerAtBeginning
        strokeWidth={2.5}
        opacity={opacity}
        onClick={GridClick}
        //opacity={globalVectorVariable.arrowClicked? 0.2:1}
      />
      {xLabel ? (
        <Image
          x={width - (xLabel.width + 10)}
          y={gridSize.originY + gridSize.height - stepSize * 5 + 10}
          fill="#F5F5F5"
          image={xLabel}
          rotation={0}
          height={xLabel.height}
          width={xLabel.width}
          opacity={opacity}
          onClick={GridClick}
        />
      ) : null}
      {xNegativeLabel ? (
        <Image
          x={0 + (xNegativeLabel.width - 10)}
          y={gridSize.originY + gridSize.height - stepSize * 5 + 10}
          fill="#F5F5F5"
          image={xNegativeLabel}
          rotation={0}
          height={xNegativeLabel.height}
          width={xNegativeLabel.width}
          opacity={opacity}
          onClick={GridClick}
        />
      ) : null}

      {yLabel ? (
        <Image
          x={gridSize.originX + stepSize * 5 + 10}
          y={yLabel.height}
          fill="#F5F5F5"
          image={yLabel}
          rotation={0}
          height={yLabel.height}
          width={yLabel.width}
          opacity={opacity}
          onClick={GridClick}
        />
      ) : null}
      {yNegativeLabel ? (
        <Image
          x={gridSize.originX + stepSize * 5 + 10}
          y={height - (yNegativeLabel.height + 10)}
          fill="#F5F5F5"
          image={yNegativeLabel}
          rotation={0}
          height={yNegativeLabel.height}
          width={yNegativeLabel.width}
          opacity={opacity}
          onClick={GridClick}
        />
      ) : null}
      <NumberLines />
    </Layer>
  );
};

export default RulerLayer;
